module.exports = __webpack_public_path__ + "static/media/Formular-Light.aea3afe0.woff";